import config from 'config'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { alertActions } from 'srcReact/Alert'
import { Tip } from 'srcReact/components/common2/Tip'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { Link } from 'react-router-dom'

class CreateOrJoin extends Component {
  constructor(props) {
    super(props)

    document.body.classList.add('create-or-join-page')
    if (!this.props.loggedIn) {
      // window.location = `${config.webUrl}/communities-at-work`
      window.location = 'https://community.mixr.net/'
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('create-or-join-page')
  }

  render() {
    const { t, isMobile, user, loggedIn, alert } = this.props
    return (
      <PageContainer pageTitle={t('workplace.create_or_join.pageTitle')} withFooter={false}>
        <div className={styles.wrapper}>
          <div className={styles.innerWrapper}>
            <div className={styles.title}>
              <h1 className={styles.titleText}>{t('workplace.create_or_join.title')}</h1>
            </div>
            <div className={styles.joinCreateWrapper}>
              <div className={styles.row}>
                <div className={styles.card}>
                  <a
                    aria-label={t('workplace.create_or_join.title_join')}
                    href={
                      !(user && loggedIn == true)
                        ? `${config.webUrl}/auth/?ruaa=` + encodeURI(config.webUrl + '/0/your-invites')
                        : '/0/your-invites'
                    }
                    className={styles.cardLink}>
                    <div className={styles.cardInnerWrapper}>
                      <div className={styles.cardImageWrapper}>
                        <img
                          alt=''
                          className={styles.cardImage}
                          src={config.assetUrl + '/images/workplace/join-a-workplace.png'}
                        />
                      </div>
                      <div className={styles.cardTextWrapper}>
                        <span className={styles.cardTitle}>{t('workplace.create_or_join.title_join')}</span>
                        <p className={styles.cardText}>{t('workplace.create_or_join.text_join')}</p>
                      </div>
                      <div className={styles.arrowWrapper}>
                        <Icon name='chevron-right' styleModifier={styles.arrow} alt='' />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.card}>
                  <a
                    aria-label={t('workplace.create_or_join.title_create')}
                    href={
                      !(user && loggedIn == true)
                        ? `${config.webUrl}/auth/?ruaa=` + encodeURI(config.webUrl + '/0/create-organization')
                        : '/0/create-organization'
                    }
                    className={styles.cardLink}>
                    <div className={styles.cardInnerWrapper}>
                      <div className={styles.cardImageWrapper}>
                        <img
                          alt=''
                          className={styles.cardImage}
                          src={config.assetUrl + '/images/workplace/create-a-workplace.png'}
                        />
                      </div>
                      <div className={styles.cardTextWrapper}>
                        <span className={styles.cardTitle}>{t('workplace.create_or_join.title_create')}</span>
                        <p className={styles.cardText}>{t('workplace.create_or_join.text_create')}</p>
                      </div>
                      <div className={styles.arrowWrapper}>
                        <Icon name='chevron-right' styleModifier={styles.arrow} alt='' />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            {!(user && loggedIn == true) && (
              <div className={styles.woLoginWrapper}>
                <p className={styles.woLoginText}>
                  {t('workplace.create_or_join.text_unlogged')}
                  <Link
                    text={t('workplace.create_or_join.text_unlogged_link')}
                    to='/auth'
                    customStyle={styles.woLoginTextLink}
                  />
                </p>
              </div>
            )}
            <Tip
              classHr={(user && loggedIn == true ? styles.marginTop4 : styles.marginTop) + ' ' + styles.marginBottom}
              text={t('workplace.create_or_join.text_tip')}
            />
          </div>
        </div>
      </PageContainer>
    )
  }
}

function mapStateToProps(state) {
  const { login, common, alert } = state
  const { user, loggedIn } = login
  const { isMobile } = common
  return { alert, isMobile, user, loggedIn }
}

const actionCreators = {
  clearAlerts: alertActions.clear
}

const ExtendedComponent = withTranslation('common')(CreateOrJoin)

const connectedCreateOrJoinPageContainer = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedCreateOrJoinPageContainer as CreateOrJoin }
